/** Shared user display utilities — used by UserMenu, UserHeaderMenu, AvatarUpload. */

export function getInitials(firstName?: string | null, lastName?: string | null, email?: string): string {
    const first = firstName?.[0] || ''
    const last = lastName?.[0] || ''
    const initials = (first + last).toUpperCase()
    return initials || (email?.[0]?.toUpperCase() ?? 'U')
}

export function getDisplayName(
    user: { firstName?: string | null; lastName?: string | null; email: string },
    maxLength = 18,
): string {
    const firstName = user.firstName || ''
    const lastName = user.lastName ? user.lastName.toUpperCase() : ''

    if (!firstName && !lastName) {
        return user.email.split('@')[0]
    }

    // Full Name "Jean DUPONT"
    const full = `${firstName} ${lastName}`.trim()
    if (full.length <= maxLength) return full

    // "Jean D."
    const initial = lastName ? `${lastName.charAt(0)}.` : ''
    const short = `${firstName} ${initial}`.trim()
    if (short.length <= maxLength) return short

    // "Jean"
    if (firstName.length <= maxLength) return firstName

    return firstName.slice(0, maxLength)
}
